/** Tokenize the raw FU command protocol, including backtick-delimited arguments. */
export function tokenizeFabulaUltimaCommand(input: string): string[] {
  const tokens: string[] = [];
  let token = "";
  let inBackticks = false;

  const pushToken = () => {
    if (token.length > 0) {
      tokens.push(token);
      token = "";
    }
  };

  for (const character of input.trim()) {
    if (character === "\n" || character === "\r") {
      throw new SyntaxError("Command must be a single line");
    }
    if (character === "`") {
      inBackticks = !inBackticks;
      continue;
    }
    if (/\s/.test(character) && !inBackticks) {
      pushToken();
      continue;
    }
    token += character;
  }

  if (inBackticks) {
    throw new SyntaxError("Unclosed backtick-delimited argument");
  }
  pushToken();
  return tokens;
}

export function formatFabulaUltimaCommandArgument(value: string): string {
  if (value.includes("`") || /[\r\n]/.test(value)) {
    throw new SyntaxError("Command arguments cannot contain backticks or newlines");
  }
  return /\s/.test(value) ? `\`${value}\`` : value;
}
